import React from 'react';
import { Row, Col } from 'react-bootstrap';
import './QualitySection.css'; // Ensure you import the CSS file
import '../App.css'

const QualitySection = () => {
    return (
        <Row className="quality-section">
            <Col sm={12} lg={12} xl={12} md={12}>
                <h4>Quality Work | On-time Delivery | Refund Policy | Full customer support</h4>
            </Col>
        </Row>
    );
};

export default QualitySection;
